import React, { useState } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Collapse, IconButton, Box, Typography
} from '@mui/material';
import {
    KeyboardArrowDown as KeyboardArrowDownIcon,
    KeyboardArrowUp as KeyboardArrowUpIcon
} from '@mui/icons-material';
import AddProfilesGridModel from '../../../models/company/addProfiles/response/AddProfilesGridModel';
import { RoleEnum } from '../../../models/enums/RoleEnum';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

interface CandidateRowProps {
    candidate: AddProfilesGridModel;
    index: number;
    loggedInUser: any;
    roleId: number;
    statusUpdate: (candidate: AddProfilesGridModel) => void;
    scheduleInterview: (candidate: AddProfilesGridModel) => void;
    viewHistory: (candidateId: string) => void;
    downloadCandidateResume: (candidateId: string, resumeTitle: string) => void;
    copyClipboard: (value: string) => void;
    viewRating: (candidate: AddProfilesGridModel) => void;
}

const AddProfilesGridChildComponent: React.FC<CandidateRowProps> = ({
    candidate,
    index,
    loggedInUser,
    roleId,
    statusUpdate,
    scheduleInterview,
    viewHistory,
    downloadCandidateResume,
    copyClipboard,
    viewRating
}) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            {/* MAIN ROW */}
            <TableRow sx={{ backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5' }}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)} className='grid-action-icon-buttons'>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>{candidate.candidateName}</TableCell>                
                <TableCell>{candidate.interviewDate}</TableCell>
                <TableCell>{candidate.totalRating}</TableCell>
                <TableCell>{candidate.statusName}</TableCell>
                <TableCell>
                    {(roleId === parseInt(RoleEnum.ClientRecruiter.toString()) || roleId === parseInt(RoleEnum.Administrator.toString())
                        || roleId === parseInt(RoleEnum.IAIRecruiter.toString())) &&
                        <>
                            <a onClick={() => { statusUpdate(candidate); }} title="Update Status">
                                <i className="fa fa-check grid-icon blue"></i>
                            </a>
                            <a onClick={() => { scheduleInterview(candidate); }} title="Schedule Interview">
                                <i className="fa fa-calendar-alt grid-icon blue"></i>
                            </a>
                        </>
                    }
                    {roleId === parseInt(RoleEnum.VendorRecruiter.toString()) &&
                        <a onClick={() => { statusUpdate(candidate); }} title="Update Status">
                            <i className="fa fa-sync-alt grid-icon blue"></i>
                        </a>
                    }
                    {candidate.isRated && (
                        <IconButton onClick={() => viewRating(candidate)} title="Rating" className='grid-action-icon-buttons'>
                            <i className="fa fa-star grid-icon blue"></i>
                        </IconButton>
                    )}
                    <a onClick={() => { viewHistory(candidate.candidateId); }} title="View History">
                        <i className="fa fa-history grid-icon blue"></i>
                    </a>
                    <a onClick={() => { downloadCandidateResume(candidate.candidateId, candidate.resumeTitle); }} title="Download Resume">
                        <i className="fa fa-download grid-icon blue"></i>
                    </a>
                </TableCell>
            </TableRow>
            {/* COLLAPSIBLE CHILD ROW */}
            <TableRow>
                <TableCell
                    className="no-padding-cell"
                    colSpan={8}
                >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Table size="small" aria-label="details">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Email Id</TableCell>
                                        <TableCell>Mobile No</TableCell>
                                        <TableCell>Created Dt</TableCell>
                                        <TableCell>Vendor</TableCell>
                                        <TableCell>Meeting Url</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>{candidate.emailId}</TableCell>
                                        <TableCell>
                                            <span>{candidate.mobileNumber}</span>
                                            <IconButton color="primary" className="grid-icon-copy-button" onClick={() => { copyClipboard(candidate.mobileNumber.toString()); }}>
                                                <ContentCopyOutlinedIcon className="grid-icon-copy" />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell>{candidate.createdDateString}</TableCell>
                                        <TableCell>{candidate.vendorName}</TableCell>
                                        <TableCell>
                                            <a href={candidate.meetingUrl} target="_blank" title={candidate.meetingUrl}>Join Meeting</a>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};
export default AddProfilesGridChildComponent;
